import React from "react";

import FatherLayout from "../../components/Parents/FatherLayout";
import BlogContent from "../../components/Parents/Blog/BlogHomeContent";

function Blog() {
    const rightParentContent = () => {
        return (
            <div>rightParentContent</div>
        );
    }

    return (
        <FatherLayout title="Blogs" rightParentContent={rightParentContent} showWelcomeBanner={true}>
            <BlogContent/>
        </FatherLayout>
    );
}

export default Blog;
